import React, { useState, useEffect, Fragment } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { saveReportTeamMemberDataAsync, saveTeamDataAsync } from "../../utils/customer/reportingTeamSlice";
import CustomDrawer from "../UniversalComponents/CustomDrawer";

import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  useFetchCustomerDepartmentQuery,
  useFetchTeamAllDataQuery,
  useLazyFetchTeamAllDataQuery,
  usePostAddTeamMemberMutation,
  usePostCustomerAddTeamMutation,
  usePostCustomerTeamRolesMutation,
  usePostCustomerTeamSkillLevelsMutation,
} from "../../utils/customer/customerSelect";
import Button from "../UniversalComponents/DefaultButton";

import { useFetchCustomerUseListDataQuery } from "../../utils/customer/customerSelect";
import { useLazyFetchPersonInTableQuery } from "../../utils/customer/customerTable";
import OwnerDropDown from "../GlobalFeature/Fields/OwnerDropDown";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import BasicSelect from "../Task/BasicSelect";
import { pushAlert } from "../../utils/alertSlice";
import { getUserToken } from "../../utils/utilityFunctions/localServices";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { getCustomerId } from "./CustomerSlice";
import LabelComponent from "../UniversalComponents/LabelComponent";
import TextAreaComponent from "../UniversalComponents/TextAreaComponent";
import BooleanSelect from "../UniversalComponents/BooleanSelect";
import InputComponent from "../UniversalComponents/InputComponent";

const validationRules = {
  user_id: {
    required: true,
    errorMessage: "user is required.",
  },
  Team: {
    required: true,
    errorMessage: "Team is required.",
  },
  Role: {
    required: true,
    errorMessage: "Role is required.",
  },
  SkillLevels: {
    required: true,
    errorMessage: "Skill Levels is required.",
  },
  Status: {
    required: true,
    errorMessage: "Status is required.",
  },
  billable: {
    required: true,
    errorMessage: "billable is required.",
  },
};

const ReportingTeamModal = ({ isOpen, onClose, teamData, refetchAllOption }) => {
  const { token } = useRequireAuth();
  const { id } = useParams();
  const customerId = parseInt(id);
  const dispatch = useDispatch();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  const [activeForm, setActiveForm] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [contactName, setContactName] = useState(null);
  const companyId = JSON.parse(localStorage.getItem("company_data")).company_id;

  const [showAddTab, setShowAddTab] = useState(false);
  const [mandatoryError, setMandatoryError] = useState(false);
  const [addformData, setAddFormData] = useState({
    customerId: "",
    teamName: "",
    description: "",
  });

  const [formData, setFormData] = useState({
    user_id: teamData?.user_id || "",
    Team: teamData?.team_id || "",
    Role: teamData?.role_id || "",
    SkillLevels: teamData?.skill_level_id || "",
    Status: teamData?.status ?? "",
    billable: teamData?.is_billable ?? "",
  });
  console.log(formData, teamData, "vinayformdata");

  const { values, errors, touched, handleChange, handleBlur, validateField, isFormValid } = useCustomFormValidation(
    formData,
    validationRules
  );

  const handleAddMember = (e) => {
    e.preventDefault();
    setMandatoryError(false);
    const formValid = isFormValid();
    if (!formValid) {
      setMandatoryError(true);
      return;
    }

    const data = {
      userId: formData.user_id,
      customerId: customerId,
      teamId: formData.Team,
      roleId: formData.Role,
      skillLevelId: formData.SkillLevels,
      status: formData.Status,
      isBillable: formData.billable,
    };

    console.log("nameValue", formData, data);
    if (teamData?.id) data.id = teamData?.id;

    addTeamMember({ data }).unwrap();
  };

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token, data: data, companyId: companyId });
  };

  useEffect(() => {
    fetchPersonData("");
  }, []);

  useEffect(() => {
    if (Boolean(teamData?.user_id)) fetchPersonData(teamData?.first_name);
  }, [teamData]);

  const handleFieldChange = (e) => {
    const { name, value, label } = e.target;
    console.log("vinayformdata tyyy", name, value);
    handleChange(e);
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };
  console.log(personTableData, "helllopersontable");

  const handleAddFieldChange = (e) => {
    const { name, value, label } = e.target;
    handleChange(e);
    setAddFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  //   event.preventDefault();

  //   const formValid = isFormValid();
  //   if (!formValid) {
  //     return;
  //   }

  //   const socialData = {
  //     customer_id: customerId,
  //     designation_id: event.target.designation_id.value,
  //     reporting_person_name: event.target.reporting_person_name.value,
  //     reporting_person_email: formData.reporting_person_email,
  //     status: event.target.status.checked ? 1 : 0,
  //     company_id: parsedCompanyData.company_id,
  //   };
  // };

  const Billable = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];

  const statusList = [
    {
      label: "Active",
      value: true,
    },
    {
      label: "Inactive",
      value: false,
    },
  ];

  const {
    data: allOptionData,
    error: AllTeamListError,
    isLoading: AllTeamListLoading,
    refetch: refetchAllOptionData,
  } = useFetchTeamAllDataQuery({ key: "all", customer_id: customerId }); // viany -- get team alldata, key

  const [
    PostAddTeam,
    { data: teamPostData, isError: teamPostError, isSuccess: teamPostSuccess, isLoading: teamPostLoading },
  ] = usePostCustomerAddTeamMutation(); //vinay -- team

  const [
    PostRolesTeam,
    { data: RolePostData, isError: RolePostError, isSuccess: RolePostSuccess, isLoading: RolePostLoading },
  ] = usePostCustomerTeamRolesMutation(); //vinay -- Roles

  const [
    PostRolesSkillLevel,
    {
      data: SkillLevelPostData,
      isError: SkillLevelPostError,
      isSuccess: SkillLevelPostSuccess,
      isLoading: SkillLevelPostLoading,
    },
  ] = usePostCustomerTeamSkillLevelsMutation(); //vinay -- SkillLevel

  const [
    addTeamMember,
    {
      data: addTeamPostData,
      isError: addTeamPostError,
      isSuccess: addTeamPostSuccess,
      isLoading: addTeamPostLoading,
      reset: resetAddTeamMember,
    },
  ] = usePostAddTeamMemberMutation(); //vinay  --- add Team

  useEffect(() => {
    //loading
    if (teamPostLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (teamPostSuccess) {
      dispatch(
        pushAlert({ message: teamPostData.message, type: teamPostData.success ? "success" : "danger", visible: true })
      );
      if (teamPostData.success) {
        refetchAllOptionData();
        setAddFormData({ customerId: "", teamName: "", description: "" });
      }
    }
    // catch block
    if (teamPostError) {
      dispatch(pushAlert({ message: teamPostData?.message, type: "danger", visible: true }));
    }
  }, [teamPostLoading, teamPostSuccess, teamPostError]);

  useEffect(() => {
    //loading state
    if (RolePostLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (RolePostSuccess) {
      dispatch(
        pushAlert({ message: RolePostData.message, type: RolePostData.success ? "success" : "danger", visible: true })
      );
      if (RolePostData.success) {
        refetchAllOptionData();
        setAddFormData({ customerId: "", name: "", description: "" });
      }
    }
    //catch block
    if (RolePostError) {
      dispatch(pushAlert({ message: RolePostData?.message, type: "danger", visible: true }));
    }
  }, [RolePostLoading, RolePostSuccess, RolePostError]);

  useEffect(() => {
    // loading state
    if (SkillLevelPostLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    // try block
    if (SkillLevelPostSuccess) {
      dispatch(
        pushAlert({
          message: SkillLevelPostData.message,
          type: SkillLevelPostData.success ? "success" : "danger",
          visible: true,
        })
      );
      if (SkillLevelPostData.success) {
        refetchAllOptionData();
        setAddFormData({ customerId: "", name: "", description: "" });
      }
    }
    // catch block
    if (SkillLevelPostError) {
      dispatch(pushAlert({ message: SkillLevelPostData?.message, type: "danger", visible: true }));
    }
  }, [SkillLevelPostLoading, SkillLevelPostSuccess, SkillLevelPostError]);

  useEffect(() => {
    //loading
    if (addTeamPostLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    //try block
    if (addTeamPostSuccess) {
      dispatch(
        pushAlert({
          message: addTeamPostData.message,
          type: addTeamPostData.success ? "success" : "danger",
          visible: true,
        })
      );
      if (addTeamPostData.success) {
        refetchAllOption();
        onClose();
      }
    }

    // catch block
    if (addTeamPostError) {
      dispatch(pushAlert({ message: addTeamPostData?.message, type: "danger", visible: true }));
    }
  }, [addTeamPostLoading, addTeamPostSuccess, addTeamPostError]);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEsc);

    // Clean up the event listener
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEsc);

    // Clean up the event listener
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  const handleAddTeam = (e) => {
    e.preventDefault();

    // const formValid = isFormValid();

    // if (!formValid) {
    //   return;
    // }

    const data = {
      description: addformData.description,
    };

    if (activeForm === "Team") {
      data.teamName = addformData.teamName;
      data.customerId = addformData.customerId;
      PostAddTeam({ data, isUpdate: false });
    } else {
      data.name = addformData.teamName;
    }

    if (activeForm === "Role") PostRolesTeam({ data });
    if (activeForm === "Skill") PostRolesSkillLevel({ data });
  };

  return (
    <CustomDrawer open={isOpen} onClose={onClose}>
      <div className="h-full  bg-white border flex flex-col w-full">
        {Boolean(activeForm) ? (
          <>
            <div className=" flex items-center justify-between py-3 px-6 border-b border-BECBD3 ">
              <h3 className="text-16 font-500 text-434852 ">Add {activeForm}</h3>
              <button
                onClick={() => setActiveForm("")}
                type="button"
                className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                data-modal-hide="assets-modal"
              >
                <CloseModalImg className="w-3 h-3" />
                <span className="sr-only">Close modal</span>
              </button>
            </div>

            <form onSubmit={handleAddTeam} className="w-full h-full grow min-h-0 flex flex-col">
              <div className="grow min-h-0">
                {/* Team Name Input Field */}
                <div className="mb-1 px-6">
                  <LabelComponent labelText="Name" htmlFor="teamName" size="medium" isMandatory />
                  <InputComponent
                    type="text"
                    id="teamName"
                    name="teamName"
                    value={addformData?.teamName || ""}
                    onChange={handleAddFieldChange}
                    mandatory
                  />
                </div>

                {/* Team Description Textarea Field */}
                <div className="mb-1 px-6">
                  <LabelComponent labelText="Description" htmlFor="description" size="medium" />

                  <TextAreaComponent
                    id={"description"}
                    name={"description"}
                    value={addformData.description || ""}
                    onChange={handleAddFieldChange}
                    placeholder="Enter Description..."
                    showResizer
                  />
                </div>
              </div>

              {/* Buttons */}
              <div className="bg-white py-4 pr-3 flex justify-end text-md w-full border-DFE2E5 border-t mt-auto">
                <div className="px-2 gap-3 flex">
                  <Button variant={"secondary"} onClick={() => setActiveForm("")}>
                    CANCEL
                  </Button>

                  <Button variant={"primary"} type={"submit"}>
                    SAVE
                  </Button>
                </div>
              </div>
            </form>
          </>
        ) : (
          <>
            <div className=" flex items-center justify-between py-3 px-6 border-b border-BECBD3 ">
              <h3 className="text-16 font-500 text-434852 ">{teamData.id ? "Edit" : "Add"}</h3>
              <button
                onClick={onClose}
                type="button"
                className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                data-modal-hide="assets-modal"
              >
                <CloseModalImg className="w-3 h-3" />
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <form
              onSubmit={handleAddMember}
              // className="w-full lg:max-h-[70vh]  overflow-hidden">
              className="w-full h-full grow min-h-0 flex flex-col"
            >
              <div className="grow min-h-0">
                {/* Team */}
                <div className=" mb-1 px-6  ">
                  <LabelComponent htmlFor="team" labelText="Team" size="medium" isMandatory />
                  <BasicSelect
                    options={allOptionData?.data?.teams?.map((option) => ({
                      label: option?.name,
                      value: option?.id,
                    }))}
                    size="medium"
                    label={"team"}
                    name="Team"
                    showSearch
                    isError={errors.Team}
                    onChange={handleFieldChange}
                    selectedOptions={
                      allOptionData?.data?.teams
                        ?.filter((option) => option.id === formData["Team"])
                        .map((option) => ({
                          label: option?.name,
                          value: option?.id,
                        })) || null
                    }
                    addButton
                    addButtonLabel={"Add Team"}
                    addButtonAction={() => setActiveForm("Team")}
                  />
                </div>

                {/* user  */}
                <div className=" mb-1 px-6  ">
                  <LabelComponent labelText="User" htmlFor="user_id" size="medium" isMandatory />

                  <BasicSelect
                    // {customerTaskUserList?.map((option) => ({
                    //   label: option?.name,
                    //   value: option?.id,
                    // }))}
                    options={personTableData?.data?.map((option) => ({
                      label: option?.name,
                      value: option?.id,
                    }))}
                    size="medium"
                    label={"user"}
                    name="user_id"
                    showSearch
                    // onSearch={(text) => fetchPersonData(text)}
                    isError={errors.user_id}
                    onChange={handleFieldChange}
                    selectedOptions={
                      personTableData?.data
                        ?.filter((option) => option.id === formData["user_id"])
                        .map((option) => ({
                          label: option?.name,
                          value: option?.id,
                        })) || null
                    }
                    // addButton
                    // addButtonLabel={"Add New Option"}
                    // addButtonAction={() => window.alert("Replace with your function")}
                  />
                </div>

                {/* Role */}
                <div className=" mb-1 px-6  ">
                  <LabelComponent labelText="Role" htmlFor="role" size="medium" isMandatory />
                  <BasicSelect
                    options={allOptionData?.data?.roles?.map((option) => ({
                      label: option?.name,
                      value: option?.id,
                    }))}
                    name="Role"
                    label={"role"}
                    size="medium"
                    isError={errors?.Role}
                    showSearch
                    onChange={handleFieldChange}
                    selectedOptions={
                      allOptionData?.data?.roles
                        ?.filter((option) => option.id === formData["Role"])
                        .map((option) => ({
                          label: option?.name,
                          value: option?.id,
                        })) || null
                    }
                    addButton
                    addButtonLabel={"Add Roll"}
                    addButtonAction={() => setActiveForm("Role")}
                  />
                </div>

                {/* Skill levels */}
                <div className=" mb-1 px-6  ">
                  <LabelComponent labelText="Skill Level" htmlFor="SkillLevels" size="medium" isMandatory />
                  <BasicSelect
                    options={allOptionData?.data?.skill_levels?.map((option) => ({
                      label: option?.level,
                      value: option?.id,
                    }))}
                    name="SkillLevels"
                    label={"skill level"}
                    size="medium"
                    showSearch
                    isError={errors.SkillLevels}
                    onChange={handleFieldChange}
                    selectedOptions={
                      allOptionData?.data?.skill_levels
                        ?.filter((option) => option.id === formData["SkillLevels"])
                        .map((option) => ({
                          label: option?.level,
                          value: option?.id,
                        })) || null
                    }
                    addButton
                    addButtonLabel={"Add Skill Levels"}
                    addButtonAction={() => setActiveForm("Skill")}
                  />
                </div>

                {/* Status */}
                <div className=" mb-1 px-6  ">
                  <LabelComponent labelText="Status" htmlFor="Status" size="medium" isMandatory />
                  <BooleanSelect
                    options={statusList}
                    name={"Status"}
                    label={"Status"}
                    size="medium"
                    showSearch
                    isError={errors.Status}
                    onChange={handleFieldChange}
                    value={formData?.Status}
                  />
                </div>

                {/* Billable */}
                <div className="mb-1 px-6">
                  <LabelComponent labelText="Billable" htmlFor="billable" size="medium" isMandatory />
                  <BooleanSelect
                    options={Billable}
                    name={"billable"}
                    label={"billable"}
                    size="medium"
                    showSearch
                    isError={errors.billable}
                    onChange={handleFieldChange}
                    value={formData?.billable}
                  />
                </div>
              </div>

              {/* submit */}
              {/* <div className="text-right py-2 px-3">
                {mandatoryError && <span className="text-red-700">Mandatory Field Missing </span>}
              </div> */}
              <div className="bg-white py-4 pr-3 flex justify-end text-md w-full  border-DFE2E5 border-t mt-auto">
                <div className="px-2 gap-3 flex">
                  <Button variant={"secondary"} onClick={onClose}>
                    CANCEL
                  </Button>

                  <Button variant={"primary"} type={"submit"}>
                    SAVE
                  </Button>
                </div>
              </div>
            </form>
          </>
        )}
      </div>
    </CustomDrawer>
  );
};

export default ReportingTeamModal;
